import {marked} from "marked";
import {isNullOrEmptyOrWhitespace} from "./stringUtils";

export const markdownToPlainTextConverter = (markdown?: string): string => {
  let result = "";
  if (markdown) {
    const htmlText = marked.parse(markdown).trim(); //Convert markdown to html text
    const htmlDoc = new DOMParser().parseFromString(htmlText, "text/html");
    result = htmlDoc.body.textContent || "";
  }
  return result;
};

export const markdownToHtmlConverter = (markdown?: string): string => {
  const renderer = new marked.Renderer();
  renderer.link = linkRenderer;

  return isNullOrEmptyOrWhitespace(markdown)
    ? ""
    : marked(markdown!, {renderer}).trim();
};

function linkRenderer(href: string, title: string, text: string) {
  return `<a target="_blank" href="${href}">${text}</a>`;
}
